import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { useTranslation } from "react-i18next"
import {
  BackofficeGenerateClusterResponseDataSchema,
  DataResponse,
  GenerateClusterFormSchema,
} from "schema"
import { toast } from "sonner"
import { z } from "zod"

type GenerateClusterData = z.infer<typeof GenerateClusterFormSchema>
type Response = DataResponse<z.infer<typeof BackofficeGenerateClusterResponseDataSchema>>

export const useGenerateClusterMutation = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: GenerateClusterData) => {
      const { data: response } = await axios.post<Response>("/backoffice/clusters/generate", data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["backofficeClusterKeys"],
      })
      toast.success(t("backoffice.clusters.generate.success"))
    },
  })
}
